export var DownlodTaxReportType;
(function (DownlodTaxReportType) {
    DownlodTaxReportType["TaxReport"] = "TaxReport";
    DownlodTaxReportType["80C"] = "80C";
    DownlodTaxReportType["ELSS"] = "ELSS";
    DownlodTaxReportType["TCSTDS"] = "TCSTDS";
    DownlodTaxReportType["DPCash"] = "DPCash";
    DownlodTaxReportType["DPBill"] = "DPBill";
})(DownlodTaxReportType || (DownlodTaxReportType = {}));
